import React, { useRef, useState } from 'react'
import { useAddNewcleanerappMutation, useGetWardsQuery } from './CleanerSlice';

function AddCleaner() {
    const [selectedValues, setSelectedValues] = useState([]);
    const [addNewcleanerapp, { isLoading }] = useAddNewcleanerappMutation()
    const [addcleanerApp, setAddcleanerApp] = useState({ name: "", number: "", ward_id_array: [] });
    const refClose = useRef(null);
    const {
        data: Wards
    } = useGetWardsQuery("getWards")

    const handleChange = (e) => setAddcleanerApp({ ...addcleanerApp, [e.target.name]: e.target.value });

    const handleClick = async (e) => {
        e.preventDefault();
        try {
            const xyz = await addNewcleanerapp({ name: addcleanerApp.name, number: addcleanerApp.number, ward_id_array: selectedValues }).unwrap()
            setAddcleanerApp({ name: "", number: "", ward_id_array: [] })
            refClose.current.click()
        }
        catch (e) {
            console.log(e, "Error");
            console.error(e)
        }
    }

    const handleCheckboxChange = (e) => {
        const value = e.target.value;
        const checked = e.target.checked;
        setSelectedValues((prevValues) => {
            if (checked) {
                return [...prevValues, value];
            } else {
                return prevValues.filter((v) => v !== value);
            }
        });
    };

    return (
        <>
            <button type="button" className="Add_button bg-left-navabr  text-light  btn btn-secondary" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas" aria-controls="depOffCanvas"><i className="fa fa-plus" aria-hidden="true"></i> Add Cleaner</button>

            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="1" id="depOffCanvas" aria-labelledby="depOffCanvas">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Add Cleaner</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refClose}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    value={addcleanerApp.name}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Number
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="number"
                                    name="number"
                                    value={addcleanerApp.number}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>

                            {/* <div className="col-md-12 text-left">
                                <label htmlFor="type" className="form-label font-weight-bold">
                                    Ward
                                </label>

                                <select className="form-select" id="active" name="active"
                                    value={addUserApp.active} onChange={handleChange}
                                    required>
                                    <option value="" defaultValue>Select</option>
                                    <option value="1" defaultValue>Yes</option>
                                    <option value="0" defaultValue>No</option>
                                </select>
                            </div> */}

                            {/* <div className="driverLive_list" >
                                <input name="ward_ids" id="50" type="checkbox" value={"4cd2"} onChange={handleCheckboxChange}  checked={selectedValues.includes("4cd2")} />
                                <label htmlFor="50" value={"4cd2"}>50 </label>
                            </div>
                            <div className="driverLive_list" >
                                <input name="ward_ids" id="93" type="checkbox" value={"a0f5"} onChange={handleCheckboxChange}  checked={selectedValues.includes("a0f5")}/>
                                <label htmlFor="93" value={"a0f5"}> 93</label>
                            </div> */}

                            {Wards?.ids?.reduce((acc, curr, index, array) => {
                                if (index % 2 === 0) {
                                    const pair = array.slice(index, index + 2);
                                    acc.push(
                                        <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
                                            {pair.map((e) => (
                                                <span key={e}>
                                                    <input
                                                        name="ward_ids"
                                                        id={Wards?.entities[e]?.ward_id}
                                                        type="checkbox"
                                                        value={Wards?.entities[e]?.ward_id}
                                                        onChange={handleCheckboxChange}
                                                        checked={selectedValues.includes(Wards?.entities[e]?.ward_id)}
                                                    />
                                                    <label htmlFor={Wards?.entities[e]?.ward_id} value={Wards?.entities[e]?.ward_id}>{Wards?.entities[e]?.ward_number}</label>
                                                </span>
                                            ))}
                                        </div>
                                    );
                                }
                                return acc;
                            }, [])}

                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round"
                                    onClick={handleClick}
                                    disabled={!(addcleanerApp.name)}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddCleaner;